import { Button, Card } from "react-bootstrap";
import { TextRight, TelephoneInboundFill, XCircle } from "react-bootstrap-icons";

const NoticeNotification = (props) => {
    const { notif, remove, openProfile, getDestUrl } = props;
    const goToEditPage = () => {
        remove(notif.ID);
        openProfile(notif.CallerInfoID, notif.Type);
    }
    return (
        <Card className="notification-card">
            <Card.Header>
                <label>
                    <TelephoneInboundFill color="#008074" />&nbsp; {notif.Title}
                </label>
                <label style={{ float: "left", marginRight: "20px" }} onClick={() => remove(notif.ID)}><XCircle color="red" size={17} style={{ cursor: "pointer" }} /></label>
                <label style={{ float: "left", fontSize: "12px" }}>اطلاعیه جدید</label>

            </Card.Header>
            <Card.Body className="row">
                <div className="col-2 mt-1" ><TextRight size={17} color="#c144d4" /></div><div className="col-9 mt-1"> {notif.NoticeSubject} </div>
                <div className="mt-2">
                    <a href={getDestUrl(notif.CallerInfoID, notif.Type)}><Button className="group-Btn-smalll w-100" onClick={goToEditPage}>لیست اطلاعیه ها</Button></a>
                </div>
            </Card.Body>
        </Card>
    )
}
export default NoticeNotification;